<script context="module">
  export class SelectHandler {
    constructor(filter) {
      this.data = {
        selected: null,
        text: null,
        open: null,
        filter
      }
    }
    store() {
      return this._store = subscribe()
    }
    action(selected, text) {
      return () => {
        this.data.selected = selected
        this.data.text = text
        this._store.set(this.data)
      }
    }
    toggleSearch(open, searchInput) {
      this.data.open = open
      this._store.set(this.data)
      if (this.data.filter) { 
        setTimeout(function() {
          open ? searchInput.focus() : null
        }, 100);
      }
    }
    async optionsInit(options, handler, selected) {
      for (const i in options) {
        options[i].onclick = handler.action(options[i].value, options[i].text)
        if (options[i].value == selected) {
          handler.action(selected, options[i].text)()
        }
        if (i == options.length - 1) {
          options.unshift({text: 'Nenhum resultado', value: 'no-matches'})
          return options
        }
      }
    }
    slugify(string) {
      return string
        .replace(/[ÁÀÂÃÄ]/gi, 'a')
        .replace(/[ÉÈÊË]/gi, 'e')
        .replace(/[ÍÌÎÏ]/gi, 'i')
        .replace(/[ÓÒÔÕÖ]/gi, 'o')
        .replace(/[ÚÙÛÜ]/gi, 'u')
        .replace(/[Ç]/gi, 'c')
        .replace(/[&]/gi, '')
        .toLowerCase() // change everything to lowercase
        .replace(/^\s+|\s+$/g, '') // trim leading and trailing spaces
        .replace(/[_|\s]+/g, '-') // change all spaces and underscores to a hyphen
        .replace(/[^a-z0-9-\/]+/g, '') // remove all non-alphanumeric characters except the hyphen and bar
        .replace(/[-]+/g, '-') // replace multiple instances of the hyphen with a single instance
        .replace(/^-+|-+$/g, '') // trim leading and trailing hyphens
    }
    search(elem, dropDown) {
      dropDown.classList.remove('no-result')
      const value = elem.value.toLowerCase()
      const list = dropDown.querySelectorAll('li')
      let match = false
      for (var i = 0; i < list.length; i++) {
        const pattern = new RegExp('\\b' + this.slugify(value), 'i');
        if (pattern.test(this.slugify(list[i].innerHTML.toLowerCase()))) {
          match = true
          list[i].classList.remove('no-match')
        } else {
          list[i].classList.add('no-match')
        }
        if (i == list.length - 1 && !match && value.length > 0) {
          dropDown.classList.add('no-result')
        }
      }
    }
  }
</script>

<script>
  import { subscribe } from '../helpers/subscribe'
  import DropDown, { DropDownHandler } from './DropDown.svelte'

  export let id, label, name, selected, options, searchInput, dropDown, filter, selectHandler, onChange, opctionsStore

  export let store = selectHandler.store()
  if (label) {
    selectHandler.action(selected, 'Escolha uma opção')()
  }

  if (!opctionsStore) opctionsStore = subscribe()
  selectHandler.optionsInit(options, selectHandler, selected)
    .then((data) => {
      opctionsStore.set({data})
    })

  export let dropDownHandler = new DropDownHandler()
  export let dropDownStore = dropDownHandler.store()
  dropDownHandler.secondaryAction = function(param) {
    selectHandler.toggleSearch(param, searchInput)
  }

  if (onChange) {
    dropDownHandler.tertiaryAction = function(param) {
      onChange(param)
    }
  }
    
</script>

<div class="select-container">
  <label class="label" for="{id}" on:click={dropDownHandler.action()} on:keydown={null}>
    {#if label}
      {label}
    {/if}
    <span class="arrow{!label ? ' no-label' : ''}">
      <ion-icon name="chevron-down-outline"></ion-icon>
    </span>
  </label>
  <div id={id} class="select" title={$store.text} on:click={dropDownHandler.action()} on:keydown={null}>
    &nbsp;
    <div class="selected-text">
      {$store.text}
    </div>
    <input class="search{$store.open ? ' active' : ''}" type="text" bind:this={searchInput} on:input={selectHandler.search(this, dropDown)} placeholder={filter ? 'Filtrar...' : 'Selecione...'}>
    <div bind:this={dropDown}>
      {#if $opctionsStore.data}
      <DropDown
        items={$opctionsStore.data}
        anchor="left"
        handler={dropDownHandler}
        store={dropDownStore}
        excludeClick={['.label', '.select', '.search', '.arrow']}
        noLineBreak={true}
        >
      </DropDown>
      {/if}
    </div>
  </div>
  <input type="hidden" name={name} value={$store.selected}>
</div>

<style lang="scss">
  @import '../scss/media-sizes';
  .select-container {
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 4px;
      background-image: url('/img/input-border.png');
      background-size: 100% 100%;
      background-position: left center;
      position: relative;
      top: -2px;
      background-repeat: no-repeat;
    }
  }
  label {
    cursor: pointer;
    position: relative;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #fff;
    .arrow {
      position: absolute;
      top: calc(100% + 16px);
      right: 7px;
      z-index: 2;
      cursor: pointer;
      :global(ion-icon) {
        display: inline-block;
        width: 18px;
        height: 18px;
      }
      &.no-label {
        top: calc(100% + 10px);
      }
    }
  }
  .select {
    position: relative;
    background-color: rgba(255,255,255,.1);
    border-radius: 3px;
    padding: 9px;
    padding-right: 33px;
    width: 100%;
    :global(.no-match) {
      display: none;
    }
    :global(.no-matches) {
      display: none;
    }
    :global(.no-result) {
      :global(.no-matches) {
        display: block;
      }
    }
    cursor: pointer;
  }
  .selected-text {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #e74989;
    color: #fff;
    border-radius: 6px;
    padding: 9px;
    padding-right: 33px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
  }
  .search {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #e74989;
    color: #fff;
    border-radius: 6px;
    padding: 9px;
    padding-right: 33px;
    width: 100%;
    cursor: auto;
    display: none;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    &:global(.active) {
      display: block
    }
  }
  @media screen and (max-width: $mediaQueryMid) {
    .select,
    .selected-text {
      padding: 12px;
      font-size: 17px;
      padding-right: 36px;
    }
    .search {
      font-size: 17px;
      padding: 12px;
      padding-right: 36px;
    }
    label {
      font-size: 16px;
      .arrow {
        top: calc(100% + 18px);
        right: 8px;
        cursor: pointer;
        :global(ion-icon) {
          width: 23px;
          height: 23px;
        }
        &.no-label {
          top: calc(100% + 12px);
        }
      }
    }
  }
</style>